import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import passwordReset from './password_reset';
import session from './session';
import register from './register';
import services from './services';
import account from './account';
import licences from './licences';
import admin from './admin';
import navbar from './navbar';
import auditLogs from './audit_logs';
import userLicences from './user_licences';
import countryCodes from './countryCodes';
import smsAuth from './smsAuth';
import googleAuth from "./googleAuth";
import mfa from './mfa';
import accessibilityStatement from './accessibility_statement';
import support from './support';

export default combineReducers({
    register,
    session,
    services,
    account,
    passwordReset,
    licences,
    admin,
    navbar,
    auditLogs,
    userLicences,
    accessibilityStatement,
    form,
    countryCodes,
    smsAuth,
    googleAuth,
    mfa,
    support,
});
